import { useEffect, useMemo } from 'react';
import uniq from 'lodash/uniq';
import { useTranslator } from '@picsart/rc/services/localization';
import { useNotifier } from '@picsart/notifier/Notifier';
import { NotificationStatuses, NotifierDuration, ToastType } from '@picsart/notifier';

import useBatchData from 'pages/Batch/sections/Context/useBatchData';
import { BatchDataStatus } from 'configs/constants';
import { BATCH_ERROR, toasterInfo } from 'pages/Batch/configs';
import analytics from 'pages/Batch/utils/analytics';
import useNetworkConnection from 'hooks/useNetworkConnection';

const useError = () => {
  const { selectedData, activeTool } = useBatchData();
  const checkIsConnected = useNetworkConnection();
  const translate = useTranslator();
  const { addNotification } = useNotifier();

  const errorData = useMemo(() => {
    const inProgress = selectedData.some(el => el.status === BatchDataStatus.IN_PROGRESS);
    return inProgress ? [] : uniq(selectedData.filter(item => item.errorType && item.status === BatchDataStatus.ERROR).map(err => err.errorType));
  }, [selectedData]);

  useEffect(() => {
    (async () => {
      if (errorData.length) {
        const isOnline = await checkIsConnected();
        (errorData as string []).forEach(err => {
          const type = isOnline ? err : BATCH_ERROR.networkDisconnected;
          addNotification({
            toastType: ToastType.Notification,
            status: NotificationStatuses.Error,
            title: translate(toasterInfo.error[type].title),
            description: translate(toasterInfo.error[type].text),
            duration: NotifierDuration.Notification,
          });
          analytics.openPopup(toasterInfo.error[err].title, activeTool);
        });
      }
    })();
  }, [checkIsConnected, errorData, activeTool, addNotification, translate]);
};

export default useError;
